<app-tab-spinner *ngIf="isLoading"></app-tab-spinner>
<div class="import-file">
  <div class="title" *ngIf="title">{{title}}</div>
  <div class="title" *ngIf="!title">Import Documents</div>
  <p-toast></p-toast>
  <div class="sub-section">
    <div class="grid field-container import-file__fields-row">
      <div class="form-group import-file__type-field" *ngIf="isGeneric">
        <div class="import-file__inline-field">
          <label for="documentType">Type</label>
          <p-select id="documentType" name="documentType" [options]="documentOptions" [(ngModel)]="selectedDocument"
            optionLabel="key" placeholder="Choose">
          </p-select>
        </div>
      </div>
      <div class="form-group import-file__description-field">
        <div class="import-file__inline-field">
          <label for="documentDescription">Description</label>
          <input id="documentDescription" name="documentDescription" pInputText="pInputText"
            [(ngModel)]="documentDescription" type="text" />
        </div>
      </div>
      <div class="col-3 form-group import-file__bank-checkbox-field" *ngIf="contractBankCheckBox">
        <div class="bank-contracts-checkbox">
          <p-checkbox id="isBankContracts" name="isBankContracts" inputId="isBankContracts"
            [(ngModel)]="isBankContracts" [binary]="true" (onChange)="onChecked($event)">
          </p-checkbox>
          <label for="isBankContracts">Is this a Bank Contracts Import file?</label>
        </div>
      </div>
    </div>
    <div class="import-file__upload-section">
      <label class="import-file__label crm-label">File</label>
      <p-fileUpload name="myfile[]" *ngIf="5000000"
        [disabled]="(!(selectedDocument && selectedDocument.key) || isLoading)" chooseLabel="Browse"
        (uploadHandler)="onUpload($event)" [customUpload]="true" (onRemove)="fileReset()">
      </p-fileUpload>
      <label class="import-file__label" *ngIf="!isGeneric">Maximum size supported 200MB</label>
      <label class="import-file__label" *ngIf="isGeneric">
        File supported formats (CSV), Maximum size supported 10MB
      </label>
      <p-progressBar [value]="uploadProgress" *ngIf="isLoading"> </p-progressBar>
    </div>
    <div *ngIf="!attachmentId">
      <div class="title">Results</div>
      <div class="content import-file__content">
        <div class="import-file__results-body">
          <ng-container *ngIf="importSummary.length>0 && this.selectedDocument.key ==='ImportPriceTable'">
            <div class="grid" *ngFor="let item of importSummary">
              <div class="col-4">
                <div class="form-group"><label>{{item.label}}</label></div>
              </div>
              <div class="col-4 text-align-center">
                <div class="form-group"><span>{{item.value}}</span></div>
              </div>
              <div class="col-4 text-align-right">
                <div *ngIf="item.key==='ValidationStatus' && item.value==='Failed'">
                  <div class="link" (click)="downloadErrorFile()">Download File</div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="fieldsNames && this.selectedDocument.key !=='ImportPriceTable'">
            <div class="grid">
              <div class="col-6">
                <div class="form-group"><label>{{fieldsNames.validation_name}}</label></div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <span>{{records.validation}}</span>
                  <div *ngIf="records.validation === 'Failed'">
                    <div class="link" (click)="downloadErrorFile()">Download File</div>
                  </div>
                </div>
              </div>
              <div class="col-6" *ngIf="contractsCount">
                <div class="form-group"><label>{{fieldsNames.total_count_name}}</label></div>
              </div>
              <div class="col-6" *ngIf="contractsCount">
                <div class="form-group"><span>{{records.total_count}}</span></div>
              </div>
              <div class="col-6">
                <div class="form-group"><label>{{fieldsNames.cost_name}} </label></div>
              </div>
              <div class="col-6">
                <div class="form-group"><span>{{records.cost}}</span></div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>